<template>
  <div class="StockStatusDesign flex items-center">
    <div
      class="w-[5px] h-[5px] desk:w-8 desk:h-8 rounded-full mr-6 relative top-1"
      :class="`bg-${color}`"
    />
    <span
      class="type-xxs desk:type-xs"
      :class="{
        'whitespace-nowrap': nowrap
      }"
      v-html="text"
    />
  </div>
</template>

<script setup lang="ts">
defineProps<{
  color: string,
  text: string,
  nowrap: boolean,
}>();

</script>

<style scoped lang="postcss">
</style>
